// extracted by mini-css-extract-plugin
module.exports = {"disableScroll":"MegaMenuMobile_disableScroll__1KDMy","iconItems":"MegaMenuMobile_iconItems__1FvdQ","contentMenu":"MegaMenuMobile_contentMenu__owNRr"};